import { Component } from '@angular/core';
import { V2_FRONT_URL } from '../../../environments/environment';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent {
  v2FrontUrl = V2_FRONT_URL;
}
